import React from 'react';
import { I18n } from 'react-redux-i18n';
import { DISC_COLORS, DISC_LABELS } from './DISCConstants';

// Spec NW-2499 — motivation color scale (applied to bar fill + percent text)
//   0–39   → low motivation (red)
//   40–57  → motivation to develop (yellow)
//   58–100 → developed / high motivation (green)
function getMotivationColor(score) {
  if (typeof score !== 'number') return '#cccccc';
  if (score < 40) return DISC_COLORS.D;
  if (score < 58) return DISC_COLORS.I;
  return DISC_COLORS.S;
}

function findCompetenciaMatch(person, competenciaId, discProfiles) {
  if (!discProfiles || discProfiles.length === 0) return null;
  const entry = discProfiles.find(
    (e) =>
      e.id_results === person.id_results ||
      e.id_results === person.id_result,
  );
  if (!entry || !Array.isArray(entry.competencia_compatibility)) return null;
  return (
    entry.competencia_compatibility.find((c) => c.id === competenciaId) || null
  );
}

function CompatibilidadCompetenciasPanel({
  selectedPersons,
  selectedCompetencias,
  discProfiles,
  compact = false,
}) {
  const hasSelections =
    selectedPersons &&
    selectedPersons.length > 0 &&
    selectedCompetencias &&
    selectedCompetencias.length > 0;

  if (!hasSelections) return null;

  // Single-user view — the panel is rendered once per person inside SingleUserView
  const person = selectedPersons[0];

  const sectionClass = `disc-chart-card disc-compat-section${
    compact ? ' disc-compat-section--compact' : ''
  }`;
  const titleClass = `disc-chart-title${compact ? ' disc-chart-title--sm' : ''}`;

  return (
    <div className={sectionClass}>
      <div className={titleClass}>
        {I18n.t('toolbox.discPanel.competenciaCompat.title')}
      </div>
      <div className="disc-compat-list">
        {selectedCompetencias.map((comp) => {
          const match = findCompetenciaMatch(person, comp.id, discProfiles);
          const score =
            match && typeof match.score === 'number' ? match.score : null;
          const factor = match ? match.factor : null;
          return (
            <CompetenciaRow
              key={comp.id != null ? comp.id : comp.title}
              competencia={comp}
              score={score}
              factor={factor}
            />
          );
        })}
      </div>
    </div>
  );
}

function CompetenciaRow({ competencia, score, factor }) {
  const color = getMotivationColor(score);
  const hasScore = typeof score === 'number';
  const displayValue = hasScore ? `${score}%` : '—';
  const width = hasScore ? `${score}%` : '0%';

  return (
    <div className="disc-compat-row">
      <div className="disc-compat-row-head">
        <div className="disc-compat-row-meta">
          {factor && (
            <span
              className="disc-compat-factor-dot"
              style={{ backgroundColor: DISC_COLORS[factor] }}
              title={`Factor DISC: ${DISC_LABELS[factor] || factor}`}
            />
          )}
          <span
            className="disc-compat-comp-name"
            title={competencia.title}
          >
            {competencia.title}
          </span>
        </div>
        <span className="disc-compat-percent" style={{ color }}>
          {displayValue}
        </span>
      </div>
      <div className="disc-compat-bar">
        <div
          className="disc-compat-bar-fill"
          style={{ width, backgroundColor: color }}
        />
      </div>
    </div>
  );
}

export default CompatibilidadCompetenciasPanel;
